import React, { useState, useEffect } from 'react';

export default function GettingStarted(props) {
	// console.log('GettingStarted', props);

	return (
		<div>
			<div>Welcome to Travltax!</div>
			<div>Dear Matthew</div>
			<div>Thank you for signing up for our sales & lodging tax solution!</div>
			<div>Next Steps:</div>
			<ul>
				<li>Supply Us with Additional Information</li>
				<div>
					If you haven't done so already, sign into our website and click the
					Finish Setup button on your dashboard to provide us with additional
					information about your rental so we can get your service started.
				</div>
				<li>Watch For A Tax Rate Email from Us</li>
				<div>
					One of our tax specialists will determine your tax requirements based
					on the information provided in step #1. We will send you an email
					detailing the taxes you should collect, how often you need to remit it
					and any other important compliance information. This can take up to a
					week after we receive the information from you.
				</div>
				<li>Respond Quickly to Our Requests</li>
				<div>
					We may need additional information from you to get your license(s). If
					we do, we will send you an email with the specifics. The faster you
					respond, the faster we can start filing your taxes.
				</div>
				<li>Collect Lodging Tax from Your Renters</li>
				<div>
					Charge and collect the required taxes from each of your renters.
				</div>
				<li>Report Your Revenue to Us</li>
				<div>
					Your taxing requirements determine how often you must report and remit
					collected taxes. We will send you a reminder email when it's time to
					report your information. When you receive it, simply sign in to our
					website and report your revenue for the specified period. That's it -
					we'll take care of everything else!
				</div>
			</ul>
		</div>
	);
}
